import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorFundApprovalReturn = () => {
  const { t } = useTranslation()
  const fundApprovalReturn = useCallback(
    (payload) => {
      const uidTransaction = payload.transaction_uid
      delete payload.transaction_uid
      ApiService.jsonRequest('/fund-bill/approval-retur', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.fund_update_success'),
            timer: 2000,
            redirect: `/order/view?uid=${uidTransaction}`,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t('response_message.fund_update_failed'),
            timer: 2000,
            redirect: `/order/view?uid=${uidTransaction}`,
          })
        }
      })
    },
    [t],
  )
  return { fundApprovalReturn }
}

export default InteractorFundApprovalReturn
